import { render, staticRenderFns } from "./SelectPessoa.vue?vue&type=template&id=f163f988"
import script from "./SelectPessoa.vue?vue&type=script&lang=js"
export * from "./SelectPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports